import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    FULL_NAME_SET_VALUE,
    FULL_NAME_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    TITLE_SET_VALUE,
    TITLE_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    KRA_NUMBER_SET_VALUE,
    KRA_NUMBER_SET_VALID,
    ID_TYPE_SET_VALUE,
    ID_TYPE_SET_VALID,
    FORM_VALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM,
    FORM_INVALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM,
    COLLECT_TRAVEL_DETAILS_FORM_DATA,
    API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM,
    API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM,
    TRAVELLERS_SET_VALUE,
    TRAVELLER_SET_VALUE,
    UPDATE_TRAVELLER_VALUE,
    SUBMIT_TRAVEL_DETAILS_FAILURE,
    SUBMIT_TRAVEL_DETAILS_SUCCESS,
    SET_CURRENT_TRAVELLER_INDEX,
    SET_TRAVELLERS_ID_VALUE,
} from '../../actions/travel/personalDetails';


export const initPersonal = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    apiCallStatus: null,
    travellers: [],
    currentTravellerIndex: null,
    form: {
        title: { value: null, error: null, status: null },
        fullName: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        idType: { value: null, error: null, status: null },
        kraNumber: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        travellerId: {value: null, error: null, status: null}
    },
};

export default (state = initPersonal, action) => {
    const mapError = error => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case TRAVELLERS_SET_VALUE:
            return { ...state, travellers: action.value };

        case SET_CURRENT_TRAVELLER_INDEX:
            return { ...state, currentTravellerIndex: action.value };

        case TRAVELLER_SET_VALUE:
            return { ...state, travellers: [...state.travellers, action.value] };

        case UPDATE_TRAVELLER_VALUE:
            let index = state?.travellers.map(function (traveller) {
                return traveller.travellerId.value;
            }).indexOf(action.id);
            
            let updatedTravellers = state?.travellers;
            updatedTravellers[index] = action.value;
            return { ...state, travellers: updatedTravellers };

        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_TRAVELLERS_ID_VALUE:
            return updateFormField('travellerId', (field) => ({
                ...field,
                value: action.value,
            }));

        case FULL_NAME_SET_VALUE:
            return updateFormField('fullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case FULL_NAME_SET_VALID:
            return updateFormField('fullName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case ID_TYPE_SET_VALUE:
            return updateFormField('idType', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_TYPE_SET_VALID:
            return updateFormField('idType', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));

        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TITLE_SET_VALUE:
            return updateFormField('title', (field) => ({
                ...field,
                value: action.value,
            }));

        case TITLE_SET_VALID:
            return updateFormField('title', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_NUMBER_SET_VALUE:
            return updateFormField('kraNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case KRA_NUMBER_SET_VALID:
            return updateFormField('kraNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        //    API Calls
        case API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        // Submit user data
        case COLLECT_TRAVEL_DETAILS_FORM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case SUBMIT_TRAVEL_DETAILS_SUCCESS:
            return { ...state, personalDetailsReferenceData: action.value };
        case SUBMIT_TRAVEL_DETAILS_FAILURE:
            return { ...state, personalDetailsReferenceData: action.error };

        // Reset the state
        case REINITIALIZE:
            return initPersonal;
        default:
            return state;
    }
};
